module.exports = __webpack_public_path__ + "static/jiva7-eda13699d81273139e9f2cdc8e44c81c.png";